import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { FaBed, FaBath } from 'react-icons/fa';
import { MdOutlineLiving } from 'react-icons/md';
import Moment from 'react-moment';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment';
import AddNewButton from '../../../pages-parts/inputs/add-new-btn/AddNewButton';


const StyledSection5 = styled.div`
    position: relative;
    width: 100%;
    transition: all .5s ease-in-out;
    margin-bottom: 3rem;
    padding: 1rem 1.75rem;
    background-color: ${({ theme }) => theme.colors.background.elements};
    border-radius: 0.75rem;
    position: relative;
    border: 1px solid #ccc;

    

    .headContainer{
        
    }
    p{
        margin: 0;
    }
    
    .infoData{
        padding: .75rem 3rem;
        border-radius: 0.75rem;
        border: 1px solid #ccc;
    }

    .secondRow{
        width: 75%;
        .periodBox{
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: auto;

            div{
                text-align: center;
            }
            h4, h5{
                margin-bottom: 0;
            }
            .infoData2{
                padding: 0;
                margin-top: 0.5rem;
            }
        }
    }
    .amenitiesBox{
        display: flex;
        .amenities{
            padding: .25rem .75rem;
            border-radius: 0.5rem;
            border: 1px solid ${({ theme }) => theme.colors.secondary};
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            margin-left: .5rem;
            .icon{
                font-size: 1.5rem;
                color: ${({ theme }) => theme.colors.secondary};
                margin-left: .5rem;
            }
            span{
    
            }
        }
    }
`;

const Section5 = ({ contractData }) => {


    return (
        <StyledSection5>
            <h2 className='sectionFloatTitle'>البيانات المالية</h2>

            <Row className='my-3 headContainer'>
                <Col className='mb-2'>
                    <h5 className='mb-0'>معلومات عن قيمة الايجار و طريقة الدفع</h5>
                </Col>
                <Col className='mb-2 text-end'>
                    <AddNewButton
                        title="تفاصيل"
                        url={`/contract-finance-record?id=${
                            contractData.contractType === "سكني" ?
                                "913c9d02-7671-44ec-a4e4-a62fce826c54" :
                                "92ce1795-8c95-4eaf-96c8-e326bcc66fb8"
                            }`}
                        isLink={true}
                        hasIcon={false}
                    />
                </Col>
            </Row>
            <Row className='my-3 secondRow'>
                <Col className='periodBox align-items-start'>
                    <div>
                        <h5>الايجار السنوي</h5>
                        <p className='infoData2'>
                            لجميع الوحدات
                        </p>
                    </div>
                </Col>
                <Col className='periodBox align-items-center'>
                    <div>
                        <h5>دفعات السداد</h5>
                        <p className='infoData2'>
                            نصف سنوي
                        </p>
                    </div>
                </Col>
                <Col className='periodBox align-items-center'>
                    <div>
                        <h5>عمولة الوسيط</h5>
                        <p className='infoData2'>
                            -
                        </p>
                    </div>
                </Col>
                <Col className='periodBox align-items-end'>
                    <div>
                        <h5>الاجمالي</h5>
                        <p className='infoData2'>
                            5600 ريال سعودي
                        </p>
                    </div>
                </Col>
            </Row>
        </StyledSection5>
    );
}

export default Section5;